import React from 'react'
import { Badge, Tooltip } from 'flowbite-react'
import { HiChevronUp, HiChevronDown, HiStar, HiTemplate } from 'react-icons/hi'

/** Catch-all / from-template / inactive badges shared by departments and AoRs. */
export const StatusBadges = ({ entity }) => (
  <>
    {entity.is_catch_all && (
      <Badge color="indigo" icon={HiStar}>
        Catch-all
      </Badge>
    )}
    {entity.default_department_id != null || entity.default_aor_id != null ? (
      <Tooltip content="Cloned from a default template for this authority type">
        <Badge color="gray" icon={HiTemplate}>
          From template
        </Badge>
      </Tooltip>
    ) : null}
    {!entity.active && <Badge color="warning">Inactive</Badge>}
  </>
)

/**
 * Up/down reorder controls. Only rendered when the caller can reorder (write
 * access and an unfiltered list, so the submitted id list stays complete).
 */
export const ReorderButtons = ({ onUp, onDown, isFirst, isLast, disabled, label }) => (
  <div className="flex flex-col">
    <button
      type="button"
      aria-label={`Move ${label} up`}
      disabled={disabled || isFirst}
      onClick={onUp}
      className="text-gray-400 hover:text-gray-700 disabled:opacity-30 disabled:hover:text-gray-400 dark:hover:text-gray-200"
    >
      <HiChevronUp className="h-4 w-4" />
    </button>
    <button
      type="button"
      aria-label={`Move ${label} down`}
      disabled={disabled || isLast}
      onClick={onDown}
      className="text-gray-400 hover:text-gray-700 disabled:opacity-30 disabled:hover:text-gray-400 dark:hover:text-gray-200"
    >
      <HiChevronDown className="h-4 w-4" />
    </button>
  </div>
)

/** Swap the item at `index` with its neighbour in `direction` (-1 up, +1 down). */
export const swap = (list, index, direction) => {
  const target = index + direction
  if (target < 0 || target >= list.length) return list
  const next = [...list]
  ;[next[index], next[target]] = [next[target], next[index]]
  return next
}
